export default[
    {
        path: '/trascor',
        component: () => import(/* webpackChunkName: "trascor" */ '@/views/Trascornea.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_ADMIN','ROLE_TRASCOR', 'ROLE_TRASCOR_ADMIN'],
        },
        children:[
            {
                path:'/',
                name:'trascorRcpt',
                component: () => import(/* webpackChunkName: "trascorRcpt" */ '@/views/trascornea/TrascorneaReceptores.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_TRASCOR', 'ROLE_TRASCOR_ADMIN'],
                },
            },
            {
                path:'donantes',
                name:'trascorDona',
                component: () => import(/* webpackChunkName: "trascorDona" */ '@/views/trascornea/TrascorneaDonantes.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_ADMIN','ROLE_TRASCOR', 'ROLE_TRASCOR_ADMIN'],
                },
            },
        ]
    }
]